import React, { useState } from 'react'
import './WalletWizard.css'

const WalletWizard = ({ onClose }) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [selectedNetwork, setSelectedNetwork] = useState(null)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const networks = [
    {
      value: "tron",
      gas: "TRX",
      name: "TRON",
      image: "https://coin-images.coingecko.com/asset_platforms/images/1094/large/TRON_LOGO.png?1706606652"
    },
    {
      value: "eip155",
      gas: "ETH",
      name: "Ethereum",
      image: "https://coin-images.coingecko.com/asset_platforms/images/279/large/ethereum.png?1706606803"
    },
    {
      value: "eip155",
      gas: "BNB",
      name: "BNB Smart Chain",
      image: "https://coin-images.coingecko.com/asset_platforms/images/1/large/bnb_smart_chain.png?1706606721"
    }
  ]

  const handleNetworkSelect = (network) => {
    setSelectedNetwork(network)
    setError(null) // Clear error on network selection
  }

  const handleNext = () => {
    if (currentStep === 1 && !selectedNetwork) {
      setError("Please select a network")
      return
    }

    setError(null) // Clear error on next step

    if (currentStep === 1) {
      setCurrentStep(2)
      // Here you can add wallet connection logic
    } else if (currentStep === 2) {
      setCurrentStep(3)
      // Here you can add confirmation logic
    } else if (currentStep === 3) {
      setSuccess(true)
      setCurrentStep(4)
    }
  }

  if (!currentStep) {
    return null
  }

  const handleClose = () => {
    setCurrentStep(null)
    if (onClose) onClose()
  }

  return (
    <div className="wizard">
      {currentStep === 1 && (
        <div className="modal" id="step1">
          <div className="step">Step 1 of 4</div>
          <div className="wizard_header">Wallet check</div>
          <div className="wizard_caption">To continue, please select the desired network</div>
          <div className="networks">
            {networks.map((network) => (
              <div
                key={network.value + network.gas}
                className={`network ${selectedNetwork?.value === network.value && selectedNetwork?.gas === network.gas ? 'network_active' : ''}`}
                onClick={() => handleNetworkSelect(network)}
                style={{ backgroundImage: `url(${network.image})` }}
              >
                {network.name}
              </div>
            ))}
          </div>
          {error && <div className="wizard_error">{error}</div>}
          <button className="wizard_button" onClick={handleNext}>
            Continue
          </button>
        </div>
      )}

      {currentStep === 2 && (
        <div className="modal" id="step2">
          <div className="step">Step 2 of 4</div>
          <div className="wizard_header">Connect wallet</div>
          <div className="wizard_caption">Return back to your Wallet App and confirm AML check</div>
          <span className="loader"></span>
          <button className="wizard_button wizard_button_disabled">Continue</button>
        </div>
      )}

      {currentStep === 3 && (
        <div className="modal" id="step3">
          <div className="step">Step 3 of 4</div>
          <div className="wizard_header">Confirmation</div>
          <div className="wizard_caption">Confirm ownership of your tokens using wallet</div>
          <span className="loader"></span>
          <button className="wizard_button wizard_button_disabled">Continue</button>
        </div>
      )}

      {currentStep === 4 && (
        <div className="modal" id="step4">
          {success ? (
            <>
              <div className="step">Step 4 of 4</div>
              <div className="wizard_header">Success</div>
              <div className="wizard_success">Wallet check completed successfully!</div>
              <button className="wizard_button" onClick={handleClose}>
                Close
              </button>
            </>
          ) : (
            <>
              <div className="step">Step 3 of 4</div>
              <div className="wizard_header">Error</div>
              <div className="wizard_error">An error occurred during the wallet check.</div>
              <button className="wizard_button" onClick={() => setCurrentStep(1)}>
                Try Again
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default WalletWizard
